import { DateHelper } from "@bryntum/schedulerpro";
import C from "../../../Constants";

export default () => {
  const build = () => {
    return {
      template: data => {
        const { eventRecord } = data;
        // 注意・警戒アラートがある場合は表示
        const alerts = eventRecord.alerts;
        let alertElements = [];
        if (alerts && alerts.length > 0) {
          alertElements.push(`<h5>以下のアラートが発生しています</h5>`);
          alerts.forEach(alert => {
            alertElements.push(`<p style="font-size: 1.2rem; margin: 0;">`);
            const iconColor =
              alert.alert_type === C.EVENT_ALERT_TYPE.CAUTION
                ? C.EVENT_ALERT_INCON_COLORS.CAUTION
                : C.EVENT_ALERT_INCON_COLORS.WARNING;
            alertElements.push(
              `<i class="b-icon b-fa-circle-exclamation" style="color:${iconColor};"></i>`
            );
            alertElements.push(alert.message);
            alertElements.push(`</p>`);
          });
        }

        let title = "役職期間";
        if (
          eventRecord.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST
        ) {
          title =
            "休暇希望・" +
            C.DAY_OFF_REQUEST_PRIORITY_NAME[eventRecord.priority];
        }

        return `
                <div class="manning-schedule-event-tooltip">
                <h5>${title}</h5>
                <p>
                  ${DateHelper.format(
                    eventRecord.startDate,
                    "YYYY/MM/DD HH:mm"
                  )}
                  -
                  ${DateHelper.format(eventRecord.endDate, "YYYY/MM/DD HH:mm")}
                </p>
                  ${alertElements.join("")}
                </div>`;
      },
    };
  };

  return {
    build,
  };
};
